// extracted by mini-css-extract-plugin
export default {"bottomSticky":"BottomSticky_bottomSticky__gf-MB"};